var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "#ffffff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 11.0001C22 4.92495 17.0751 8.58307e-05 11 8.58307e-05C4.92486 8.58307e-05 0 4.92495 0 11.0001C0 16.4905 4.02254 21.0412 9.28125 21.8665V14.1798H6.48828V11.0001H9.28125V8.57665C9.28125 5.81977 10.9235 4.29696 13.4361 4.29696C14.6396 4.29696 15.8984 4.5118 15.8984 4.5118V7.21884H14.5114C13.1449 7.21884 12.7188 8.06676 12.7188 8.93666V11.0001H15.7695L15.2818 14.1798H12.7188V21.8665C17.9775 21.0412 22 16.4905 22 11.0001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.a3e5d569.svg";
export { ForwardRef as ReactComponent };